import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const reasonsBankTransactionConstants = {
  GET_ACCOUNTING_REASONS_START: "GET_ACCOUNTING_REASONS_START",
  GET_ACCOUNTING_REASONS_SUCCESS: "GET_ACCOUNTING_REASONS_SUCCESS",
  GET_ACCOUNTING_REASONS_ERROR: "GET_ACCOUNTING_REASONS_ERROR",
  CLEAR_ACCOUNTING_REASONS: "CLEAR_ACCOUNTING_REASONS"
};

export function getReasonsBankTransaction(classification) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/reasons?managerId=${managerId}&itemId=${itemId}${classification ? "&classification=" + classification : ""}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_ERROR
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_ERROR
          });
          reject();
        });
    });
  };
}

export function clearReasonsBankTransaction() {
  return (dispatch, getState) => {
    dispatch({
      type: reasonsBankTransactionConstants.CLEAR_ACCOUNTING_REASONS
    });
  };
}
